// extracted by mini-css-extract-plugin
module.exports = {"Container":"Header_Container__2G5id","Static":"Header_Static__1MPPZ","Title":"Header_Title__1kZg6","CloseBtn":"Header_CloseBtn__s3KYW"};